import { useQuery } from "@tanstack/react-query";
import {
  getDatabricksSummaryCostOverview,
  getDatabricksSummaryCostTotalEstimate,
  getDatabricksSummaryCostTrendsByProduct,
  getDatabricksSummaryCostTrendsEstimate,
  getDatabricksSummarySavingsOverall,
  getDatabricksSummarySavingsOverallEstimate,
} from "@/helpers/apis";
import type { SummaryCostParams, SummarySavingsParams, SummaryTrendsParams } from "../types";

export const useDatabricksCostOverview = (params: SummaryCostParams, enabled = true) =>
  useQuery({
    queryKey: ["databricks-summary-cost-overview", params.start_date, params.end_date],
    queryFn: () => getDatabricksSummaryCostOverview(params),
    enabled,
  });

export const useDatabricksCostTrendsByProduct = (params: SummaryTrendsParams, enabled = true) =>
  useQuery({
    queryKey: [
      "databricks-summary-cost-trends-by-product",
      params.start_date,
      params.end_date,
      params.granularity,
      params.category,
    ],
    queryFn: () => getDatabricksSummaryCostTrendsByProduct(params),
    enabled,
  });

export const useDatabricksCostTrendsEstimate = (params: SummaryTrendsParams, enabled = true) =>
  useQuery({
    queryKey: [
      "databricks-summary-cost-trends-estimate",
      params.start_date,
      params.end_date,
      params.category,
    ],
    queryFn: () => getDatabricksSummaryCostTrendsEstimate(params),
    enabled,
  });

export const useDatabricksCostTotalEstimate = (params: SummaryCostParams, enabled = true) =>
  useQuery({
    queryKey: ["databricks-summary-cost-total-estimate", params.start_date, params.end_date],
    queryFn: () => getDatabricksSummaryCostTotalEstimate(params),
    enabled,
  });

export const useDatabricksSavingsOverall = (params: SummarySavingsParams, enabled = true) =>
  useQuery({
    queryKey: ["databricks-summary-savings-overall", params.start_date, params.end_date],
    queryFn: () => getDatabricksSummarySavingsOverall(params),
    enabled,
  });

export const useDatabricksSavingsOverallEstimate = (params: SummarySavingsParams, enabled = true) =>
  useQuery({
    queryKey: [
      "databricks-summary-savings-overall-estimate",
      params.start_date,
      params.end_date,
      params.savings_period,
    ],
    queryFn: () => getDatabricksSummarySavingsOverallEstimate(params),
    enabled,
  });
